module.exports = __webpack_public_path__ + "img/kommune-1743.71196d31.svg";